import Image from "next/image";
import Link from "next/link";
import { useEntities } from "@/contexts/entities/EntitiesContext";
import Analytics from "@/lib/analytics";
import { Competency } from "@/lib/models";
import { CompetencyActivityCounter } from "./CompetencyActivityCounter";

type OutcomeAreaCompetencyRowProps = {
  outcomeAreaId: string;
};

export const OutcomeAreaCompetencyRow = ({
  outcomeAreaId,
}: OutcomeAreaCompetencyRowProps) => {
  const { getOutcomeArea, getCompetency, getActivitiesForCompetency } =
    useEntities();

  const handleClick = (competency: Competency) => {
    const numberOfActivities = getActivitiesForCompetency(competency.id).length;
    Analytics.handleCompetencyCardClick({
      competency,
      activityCount: numberOfActivities,
    });
  };

  const outcomeArea = getOutcomeArea(outcomeAreaId)!;
  const competencies = outcomeArea.competencies.map(getCompetency);

  return (
    <section>
      <h3 className="text-center font-roobert text-xl font-medium leading-tight text-black">
        {outcomeArea.name}
      </h3>

      <div className="mb-10 mt-6 flex flex-row gap-1.5">
        {competencies.map((competency) => {
          if (
            !competency ||
            !competency.competencyCard?.sourceUrl ||
            !competency.namedIcon?.sourceUrl
          ) {
            return null;
          }

          return (
            <Link
              key={competency.id}
              href={{
                pathname: "/",
                query: { selection: competency.id },
              }}
              shallow={true}
              aria-label={`Competency Card ${competency.id}`}
              className="group relative h-[170px] w-[148px]"
              onClick={() => handleClick(competency)}
            >
              <Image
                src={competency.namedIcon.sourceUrl}
                width={148}
                height={170}
                alt={competency.name}
                className="absolute h-[170px] w-[148px] transition duration-300 ease-in-out group-hover:invisible group-hover:scale-[1.4]"
              />
              <div className="invisible relative z-20 block h-[170px] w-[148px] max-w-max drop-shadow-[0_8px_8px_rgba(0,0,0,0.30)] transition duration-300 ease-in-out hover:scale-[1.4] group-hover:visible">
                <Image
                  src={competency.competencyCard.sourceUrl}
                  width={206}
                  height={238}
                  alt={competency.name + " details"}
                />
                <CompetencyActivityCounter
                  competencyId={competency.id}
                  className="absolute left-[47px] top-[125px] z-30 h-[23px] w-[45px]"
                />
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
};
